import axios from 'axios';
import qs from 'querystring';

const API_URL = process.env.VUE_APP_API_URL;

export const listLiveDuoDataLeerlingen = (search = '') => {
  const filter = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    resource_id: 'e12c0cd1-3637-455d-af2f-718c607fce4a',
    q: search,
  };

  // cannot do because of CORS ofcourse.
  return axios({
    method: 'get',
    url: 'https://onderwijsdata.duo.nl/api/3/action/datastore_search',
    params: filter,
  }).then(({ data }) => {
    console.log({ data });
  });
};

// this dataset contains info regarding all individual leerlingen
export const listDuoDataLeerlingen = (filter: any = {}) => axios({
  method: 'get',
  url: `${API_URL}/duo_leerlingen_vestiging_postcode`,
  params: filter,
});

export const listDuoDataSlagingsPercentage = (filter: any = {}) => axios({
  method: 'get',
  url: `${API_URL}/duo_slagingspercentages_en_gemiddelde_examencijfers`,
  params: filter,
});

export const listDuoDataExamenCijfers = (filter: any = {}) => axios({
  method: 'post',
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  url: `${API_URL}/duo_afgenomen_examens_en_gemiddelde_examencijfers`,
  data: qs.stringify(filter),
});

export const listDuoDataZittenblijversByBrin = (brin: string) => axios({
  method: 'get',
  url: `${API_URL}/scholen/${brin}/zittenblijvers_data`,
});

export const getDuoDataZittenblijversAggregates = () => axios({
  method: 'get',
  url: `${API_URL}/duo_data/zittenblijvers_aggregates`,
});

export default {
  listLeerlingen: listDuoDataLeerlingen,
  listLiveLeerlingen: listLiveDuoDataLeerlingen,
  listSlagingsPercentage: listDuoDataSlagingsPercentage,
  listExamencijfers: listDuoDataExamenCijfers,

  getZittenblijversByBrin: listDuoDataZittenblijversByBrin,
  getZittenblijversAggregates: getDuoDataZittenblijversAggregates,
};
